module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE5SURBVHgBrVMLccMwDFWGwBA8BoaQMSiEQCiDhcE6BBmDQugNQcogEFoGqnT3clVdp1HS6O5dnGfrWT9XVDBmDvKJggDqXFXVldaaCgp+BBd+tk4QaamJUxIMEG1VBFC+wZ4iLRGNcOpfRSV7f7g4eoU7CM86yJmjZkCOgwE1bAp8pLUmzjWEk+GiaeDJFWFmH2Z9MesA/OJ/LJV7MlT4aT5lZs/gr7L+ku+n4F9QCwZXFqilpr3P+BZ8yPgGwjybBcZosCKmqfsJn2j8yr0wzeoyXg+faMYKWSS7mSDeG26cmNohrsEdcL4tbe4yTi87TIjpxd8m2rEkkRyRTDUxF2t5yYMqNRFlY6Qeaa3lTcSI8VuiEHpoIjo/Oy1e8R6pj5c0tIWZJh4hHGgL4/vT5/whbSG+847VDTSlGxQUs8/rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/43d0e88.png
// module id = YIHG
// module chunks = 1